module.exports = __webpack_public_path__ + "img/book3.1205dd59.png";